import axios from 'axios';

export default {
  getCapabilities: () => axios.get('capabilities', { skipLoading: true }),
};
